export default {
  toastClose: {
    id: 'toast_close_alternative_text',
    defaultMessage: 'Close',
  },
  toastSuccessTitle: {
    id: 'cookies_settings_toast_success_title',
    defaultMessage: 'Perfect!',
  },
  toastSuccessMessage: {
    id: 'cookies_settings_toast_success_message',
    defaultMessage: 'Your settings have been saved!',
  },
  toastErrorTitle: {
    id: 'cookies_settings_toast_error_title',
    defaultMessage: 'Oops!',
  },
  toastErrorMessage: {
    id: 'cookies_settings_toast_error_message',
    defaultMessage: 'Something went wrong',
  },
}
